(() => {
  const selector = "[data-testid='product-list'] slideshow-component.resource-list__carousel";
  const initialized = new WeakSet();

  function initialize(carousel) {
    if (!(carousel instanceof HTMLElement) || initialized.has(carousel)) return;

    const scroller = carousel.querySelector('slideshow-slides');
    if (!(scroller instanceof HTMLElement)) return;

    initialized.add(carousel);

    const update = () => {
      const canScroll = scroller.scrollWidth - scroller.clientWidth > 2;
      carousel.dataset.canScroll = String(canScroll);
    };

    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(carousel);
    resizeObserver.observe(scroller);

    const contentObserver = new MutationObserver(update);
    contentObserver.observe(scroller, { childList: true, subtree: true });

    requestAnimationFrame(update);
  }

  function initializeAll(root = document) {
    if (root instanceof Element && root.matches(selector)) initialize(root);
    root.querySelectorAll?.(selector).forEach(initialize);
  }

  const start = () => {
    initializeAll();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) initializeAll(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
